module.exports = __webpack_public_path__ + "img/xxp.38b8d0eb.jpg";